import React from "react";

import "./styles.scss";

export const FormControlCheckout = ({
  className,
  hasError,
  children,
  label,
  htmlFor,
  informativePopover,
  glyph,
}) => {
  return (
    <div
      className={`form-control ${className ?? ""} ${
        hasError ? "_error_3q5yg_111" : ""
      }`}
    >
      <div className="flex items-center h-5 gap-ride-gl-spacing-medium">
        <label
          htmlFor={htmlFor}
          className="ride-sys-text-label-medium-semibold"
        >
          {label}
        </label>
        {informativePopover && informativePopover}
      </div>
      <div className={"input-container"}>
        {glyph && (
          <div className="glyph-container">
            <div className="_ride-glyph_bp3nw_1 _size-x-large_bp3nw_18">
              {glyph}
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
